import React, { useState } from "react";
import {
  Col,
  Input,
  Row,
  Form,
  DatePicker,
  Select,
  TimePicker,
  Radio,
  message,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import CommonFunctions from "../../Shared/CommonFunctions";
import enrollmentServices from "../../../Services/enrollmentServices";
import AppointmentService from "../../../Services/AppointmentService";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserWalletDetails } from "../../../Redux/actions/UserActions";
import PatientService from "../../../Services/PatientService";

function AddNewPatient({
  getAppointmentList,
  onClose,
  form,
  handleKeyPress,
  accountDetails,
  setRadioValue,
  setMobileNumber,
}) {
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [save, setSave] = useState(false);
  const [paymentType, setPaymentType] = useState("Cash");
  const [paymentReceived, setPaymentReceived] = useState(true);
  const [callType, setCallType] = useState("APPT_VIDEO");
  const [endTime, setEndTime] = useState(null);
  const [submitType, setSubmitType] = useState(null);
  const [applyRegFee, setApplyRegFee] = useState(true);
  const [showFields, setShowFields] = useState(false);
  const [showFields2, setShowFields2] = useState(false);
  const [consReason, setConsReason] = useState("");
  const [consCode, setConsCode] = useState("");
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const { walletDetails, walletAmount } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await AppointmentService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleConsReasonChange = (e) => {
    setConsReason(e.target.value);
    let value = e.target.value;
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const handleConsSelectChange = (reason) => {
    setConsReason(reason?.chiefComplaint ? reason?.chiefComplaint : "");
    setConsCode(reason?.complaintCode ? reason?.complaintCode : "");
    setConsultationReasonList([]);
  };

  const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
  };

  const handleCallTypeChange = (value) => {
    setCallType(value);
    if (value === "APPT_INPERSON") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.inpersonFee
          ? loginResultObject.user.inpersonFee
          : 0,
      });
    } else if (value === "APPT_VIDEO") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.videoFee
          ? loginResultObject.user.videoFee
          : 0,
      });
    } else if (value === "APPT_AUDIO") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.audioFee
          ? loginResultObject.user.audioFee
          : 50,
      });
    } else if (value === "APPT_HOMEVISIT") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.homeVisitFee
          ? loginResultObject.user.homeVisitFee
          : 0,
      });
    }
  };

  const handleCancelClick = () => {
    setPaymentType("Cash"); //changed
    setCallType("APPT_VIDEO");
    onClose();
  };

  const handleMobileChange = async (e) => {
    const value = e.target.value;
    if (setMobileNumber) setMobileNumber(value); // Keep parent state in sync

    if (value && value.length === 10 && /^\d+$/.test(value)) {
      try {
        const payload = { mobile: value };
        const result = await PatientService.PatientListFilter(payload);
        if (result.data && result.data.length > 0) {
          message.warning(
            "Patient already exists. Switching to existing patient form...",
          );
          if (form) form.resetFields();
          if (setRadioValue) setRadioValue("existingPatient");
          if (setMobileNumber) setMobileNumber(value);
        }
      } catch (error) {
        console.error("Failed to fetch patient list:", error);
      }
    }
  };

  const handleClick = async (payload) => {
    payload.consultationReason = consReason;
    payload.complaintCode = consCode;
    payload.createdDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss",
    );
    payload.modifiedDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss",
    );
    payload.appointmentDate = CommonFunctions.convertDate(
      payload.appointmentDate,
    );

    payload.firstName =
      payload.firstName.charAt(0).toUpperCase() + payload.firstName.slice(1);
    payload.startTime = dayjs(payload.startTime).local().format("hh:mm A");
    payload.endTime = dayjs(payload.endTime).local().format("hh:mm A");
    payload.createdBy = loginResultObject.user.userId;
    payload.modifiedBy = loginResultObject.user.userId;
    payload.dob = payload.dob
      ? dayjs(payload?.dob, "MM/DD/YYYY").format("MM/DD/YYYY")
      : "";
    payload.userId = loginResultObject.user.userId;
    payload.account_Id = loginResultObject.user.account_Id;
    payload.clinic_Id = loginResultObject.user.clinic_Id;
    payload.patientType = "N";
    payload.specialityCode = loginResultObject.user?.specialityCode;
    payload.serviceName =
      payload.serviceCode === "APPT_VIDEO"
        ? "Video Consultation"
        : payload.serviceCode === "APPT_AUDIO"
          ? "Audio Consultation"
          : payload.serviceCode === "APPT_INPERSON"
            ? "Inperson Consultation"
            : payload.serviceCode === "APPT_HOMEVISIT"
              ? "Home Visit Consultation"
              : "";

    // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // if (emailRegex.test(payload.email)) {
    // } else {
    //   message.error("enter valid email in the send invite");
    //   return;
    // }

    payload.patientRegFeeYN = applyRegFee ? "Y" : "N";
    payload.patientRegFee = applyRegFee ? payload.patientRegFee : 0;

    payload.totalAmount =
      parseFloat(payload.patientRegFee) + parseFloat(payload.consultationFee);

    if (submitType === "1") {
      if (payload.totalAmount <= 0) {
        message.error("Enter Valid Amount to Proceed payment");
        setSave(false);
        return;
      }
      setSave(true);
      payload.status = -1;
      payload.paymentReceived = "N";
      payload.paymentType = "Digital";

      let data = JSON.stringify(payload);

      CommonFunctions.NewPatientPayment(data)
        .then((res) => {
          if (res && res.data && res.data.code === "FAILED") {
            if (
              res.data.message &&
              (res.data.message.toLowerCase().includes("exist") ||
                res.data.message.toLowerCase().includes("registered"))
            ) {
              message.warning(
                "Patient already exists. Switching to existing patient form...",
              );
              if (form) form.resetFields();
              if (setRadioValue) setRadioValue("existingPatient");
              if (setMobileNumber) setMobileNumber(payload.mobile);
            } else {
              message.error(res.data.message);
            }
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error);
          message.error("An Error occurred, try again");
        })
        .finally(() => {
          setSave(false);
          if (loginResultObject?.user?.currencyCode != "INR") {
            getAppointmentList();
            form.resetFields();
            onClose();
          }
        });
    } else if (submitType === "2") {
      payload.paymentType = paymentType;
      if (payload.paymentType == "Cash" && !paymentReceived) {
        message.error("Confirm Payment received by clicking the check box");
        setSave(false);
        return;
      }
      if (payload.paymentType == "VirtualCash") {
        payload.walletId = walletDetails.walletId;
        payload.txnType = "DEBIT";
        payload.status = 1;
        payload.paymentReceived = "Y";
        if (walletAmount < payload.totalAmount) {
          message.error("Required Amount not available in the wallet");
          setSave(false);
          return;
        }
      }
      setSave(true);
      try {
        payload.paymentReceived = paymentReceived ? "Y" : "N";
        payload.status = 1;
        if (payload.totalAmount == 0) {
          payload.paymentType = "Cash";
          payload.paymentConsultation = "BC";
          payload.paymentReceived = "Y";
          payload.status = 1;
        }
        let data = JSON.stringify(payload);
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          if (
            result.data.message &&
            (result.data.message.toLowerCase().includes("exist") ||
              result.data.message.toLowerCase().includes("registered"))
          ) {
            message.warning(
              "Patient already exists. Switching to existing patient form...",
            );
            if (form) form.resetFields();
            if (setRadioValue) setRadioValue("existingPatient");
            if (setMobileNumber) setMobileNumber(payload.mobile);
          } else {
            message.error(result.data.message);
          }
          setSave(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("New Patient Registration Successfull");
          message.success("Invitation sent Successfully");
          getAppointmentList();
          form.resetFields();
          onClose();
        }
      } catch (error) {
        console.error("An error occurred:", error);
        message.error("An Error occured please try again");
      } finally {
        setSave(false);
      }
    } else if (submitType == "3") {
      setSave(true);
      try {
        if (
          payload.paymentType == "Digital" &&
          payload.paymentConsultation == "AC"
        ) {
          message.error(
            "Share payment link is not available for After Consultation",
          );
          setSave(false);
          return;
        }
        if (payload.totalAmount <= 0) {
          message.error("Enter Valid Amount to share payment Link");
          setSave(false);
          return;
        }
        payload.status = 0;
        payload.paymentType = "Share_Link";
        let data = JSON.stringify(payload);
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          if (
            result.data.message &&
            (result.data.message.toLowerCase().includes("exist") ||
              result.data.message.toLowerCase().includes("registered"))
          ) {
            message.warning(
              "Patient already exists. Switching to existing patient form...",
            );
            if (form) form.resetFields();
            if (setRadioValue) setRadioValue("existingPatient");
            if (setMobileNumber) setMobileNumber(payload.mobile);
          } else {
            message.error(result.data.message);
          }
          setSave(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("New Patient Registration Successfull");
          message.success("Payment Link and invitation sent Successfully");
          getAppointmentList();
          form.resetFields();
          onClose();
        }
      } catch (error) {
        console.error("An error occurred:", error);
        message.error("An Error occured please try again");
      } finally {
        setSave(false);
      }
    }
  };

  const handleStartTimeChange = (time) => {
    if (time) {
      const endTime = dayjs(time).add(15, "minutes");
      setEndTime(endTime);
      form.setFieldsValue({ endTime });
    } else {
      setEndTime(null);
    }
  };

  const genders = [
    {
      value: "M",
      label: "Male",
    },
    {
      value: "F",
      label: "Female",
    },
  ];

  const disabledFutureDate = (current) => {
    return current && current > new Date().setHours(23, 59, 59, 999);
  };

  const onPaymentStatusChange = () => {
    setPaymentReceived(!paymentReceived);
  };

  const onPaymentTypeChange = (value) => {
    // changed
    setPaymentType(value);
    if (value === "Cash") {
      setPaymentReceived(true);
      form.setFieldsValue({ paymentConsultation: "BC" });
    } else if (value === "VirtualCash") {
      let payload = {
        userId: loginResultObject.user.userId,
        account_Id: loginResultObject.user.account_Id,
        clinic_Id: loginResultObject.user.clinic_Id,
      };
      dispatch(fetchUserWalletDetails(payload));
      setPaymentReceived(true);
      form.setFieldsValue({ paymentConsultation: "BC" });
    } else if (value === "Digital") {
      form.setFieldsValue({ paymentConsultation: "BC" });
      setPaymentReceived(false);
    } else {
      form.setFieldsValue({ paymentConsultation: null });
      setPaymentReceived(false);
    }
  };

  const handleSubmitType = (type) => {
    setSubmitType(type);
  };

  const onFeeCheckBoxChage = () => {
    setApplyRegFee(!applyRegFee);
  };

  const handleAmountRestriction = (e) => {
    const { key, target } = e;
    const value = target.value;

    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) {
      return;
    }

    if (!/[0-9.]/.test(key)) {
      e.preventDefault();
      return;
    }

    if (key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }

    const [intPart, decimalPart] = value.split(".");

    if (!value.includes(".") && intPart.length >= 6) {
      e.preventDefault();
      return;
    }

    if (value.includes(".") && decimalPart?.length >= 2) {
      e.preventDefault();
    }
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleClick}
        className="custom-input  mt-3"
        initialValues={{
          serviceCode: "APPT_VIDEO",
          paymentType: "Cash",
          consultationFee: loginResultObject.user.videoFee,
          paymentConsultation: "BC",
          appointmentDate: dayjs(),
          patientRegFee: accountDetails.patientRegFee,
          startTime: dayjs(),
          endTime: dayjs().add(15, "minutes"),
        }}
      >
        <div className="rounded-lg bg-white p-3 shadow-lg">
          <Row gutter={24}>
            <Col span={12}>
              <div className="relative">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Name <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter  Name!",
                    },
                    {
                      max: 40,
                      message: "Name must be less than 40 characters",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder=""
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    onKeyDown={(e) => {
                      if (!/[A-Za-z ]/.test(e.key) && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                    name="firstName"
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Mobile <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="mobile"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Mobile Number!",
                    },
                  ]}
                >
                  <Input
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    type="text"
                    maxLength={15}
                    onKeyDown={handleKeyPress}
                    onChange={handleMobileChange}
                    placeholder="Mobile"
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row gutter={24}>
            {true && (
              <>
                <Col span={12}>
                  <div className="relative mt-2">
                    <span className="absolute -top-2 z-10 left-3 bg-white px-1 ">
                      Email ID
                    </span>
                    <Form.Item name="email">
                      <Input
                        type="text"
                        placeholder=""
                        className="w-full mt-1 rounded-lg px-4 py-2"
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={12}>
                  <div className="relative mt-2">
                    <span className="absolute -top-2 z-10 left-3 bg-white px-1 ">
                      D.O.B
                    </span>
                    <Form.Item name="dob">
                      <DatePicker
                        className="w-full mt-1 rounded-lg px-4 py-2"
                        format={"DD/MM/YYYY"}
                        disabledDate={disabledFutureDate}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-3 z-10 left-3 bg-white px-1 ">
                      Gender
                    </span>
                    <Form.Item name="gender">
                      <Select className="w-full" options={genders} />
                    </Form.Item>
                  </div>
                </Col>
              </>
            )}
          </Row>
        </div>
        <div className="rounded-lg bg-white p-3 mt-5 shadow-lg">
          <Row gutter={24}>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Appointment Date <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="appointmentDate"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter appointmentDate!",
                    },
                  ]}
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    defaultValue={dayjs()}
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    disabledDate={disabledDate}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-3">
                <span className="absolute -top-2 z-10 left-3 bg-white px-1  text-xs">
                  Service Type <span className="text-red-500">*</span>
                </span>

                <Form.Item
                  name="serviceCode"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Consultation Type!",
                    },
                  ]}
                >
                  <Select
                    defaultValue={"APPT_VIDEO"}
                    showSearch={false}
                    className="w-full"
                    placeholder="Search to Consltations"
                    onChange={handleCallTypeChange}
                  >
                    <Select.Option value="APPT_VIDEO">Video</Select.Option>
                    <Select.Option value="APPT_AUDIO">Audio</Select.Option>
                    <Select.Option value="APPT_INPERSON">
                      In-person
                    </Select.Option>
                    <Select.Option value="APPT_HOMEVISIT">
                      Home Visit
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Start Time <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="startTime"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Start Time!",
                    },
                  ]}
                >
                  <TimePicker
                    use12Hours
                    format="h:mm a"
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    onChange={handleStartTimeChange}
                    minuteStep={5}
                    needConfirm={false}
                    allowClear={false}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  End Time <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="endTime"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter End Time!",
                    },
                  ]}
                >
                  <TimePicker
                    id="endTime"
                    use12Hours
                    format="h:mm a"
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    value={endTime}
                    minuteStep={5}
                    needConfirm={false}
                    allowClear={false}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col className={`${true ? "block" : "hidden"}`} span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-3 z-10 left-2 bg-white px-1 ">
                  Reason for Consultation
                </span>
                <Form.Item name="consultationReason">
                  <div>
                    <Input
                      placeholder="Reason"
                      value={consReason}
                      onChange={handleConsReasonChange}
                      className={`rounded-md`}
                    />

                    {consultationReasonList.length > 0 && (
                      <ul className="absolute top-12 left-0 w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20">
                        {consultationReasonList.map((reason, index) => (
                          <li
                            onClick={() => handleConsSelectChange(reason)}
                            key={index}
                            className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                          >
                            {reason.chiefComplaint}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </Form.Item>
              </div>
            </Col>
            <Col className={`${true ? "block" : "hidden"}`} span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-3 z-10 left-2 bg-white px-1 ">
                  {`Enter Fees (${loginResultObject?.user?.currencyCode || ""})`}
                </span>
                <Form.Item
                  name="consultationFee"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Total Amount!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Amount"
                    onKeyDown={handleAmountRestriction}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>
        <div className="bg-white rounded-lg  p-3 mt-5 shadow-lg">
          <Row gutter={24}>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-2 z-10 left-2 px-1 ">
                  Payment
                </span>
                <Form.Item
                  name="paymentConsultation"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Payment Consultation!",
                    },
                  ]}
                >
                  <Radio.Group
                    className="custom-radio mt-5"
                    disabled={
                      paymentType === "Cash" ||
                      paymentType === "VirtualCash" ||
                      paymentType === "Digital"
                        ? true
                        : false
                    }
                  >
                    <Radio value="BC" className="text-black">
                      Before
                    </Radio>
                    <Radio value="AC" className="text-black">
                      After
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-3">
                <span className="absolute -top-2 z-10 left-3 bg-white px-1  text-xs">
                  Payment Type <span className="text-red-500">*</span>
                </span>

                <Form.Item
                  name="paymentType"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Payment Type!",
                    },
                  ]}
                >
                  <Select
                    defaultValue={"Cash"}
                    showSearch
                    className="w-full text-xs"
                    placeholder="Search to Payment mode"
                    onChange={onPaymentTypeChange}
                  >
                    <Select.Option value="Cash">Cash</Select.Option>
                    <Select.Option value="Digital">
                      Digital Payment
                    </Select.Option>
                    {/* <Select.Option
                      className="text-[#A0A2A3] text-xs"
                      value="VirtualCash"
                    >
                      Virtual Cash
                    </Select.Option> */}
                  </Select>
                </Form.Item>
              </div>
            </Col>
            {accountDetails.patientRegFeeYN === "Y" && (
              <>
                <Col span={12}>
                  <Form.Item name="patientRegFeeYN">
                    <div>
                      <Checkbox
                        checked={applyRegFee}
                        className="mr-2"
                        onChange={onFeeCheckBoxChage}
                      />
                      Registration Fee
                    </div>
                  </Form.Item>
                </Col>
              </>
            )}
            {applyRegFee && (
              <Col span={12}>
                <div className="relative mt-2">
                  <span className="absolute -top-2 z-10 left-3 bg-white px-1  text-xs">
                    {`Registration Fees (${loginResultObject?.user?.currencyCode || ""})`}
                  </span>
                  <Form.Item name="patientRegFee">
                    <Input
                      className="w-full"
                      placeholder=""
                      onKeyDown={handleAmountRestriction}
                    />
                  </Form.Item>
                </div>
              </Col>
            )}
            {paymentType == "Cash" && (
              <>
                <Col>
                  <Form.Item name="">
                    <div>
                      <Checkbox
                        checked={paymentReceived}
                        className="mr-2"
                        onChange={onPaymentStatusChange}
                      />
                      Payment Received
                    </div>
                  </Form.Item>
                </Col>
                <Col span={12}></Col>
              </>
            )}
            {paymentType == "VirtualCash" && (
              <div className="mt-3 text-[#A0A2A3] text-xs flex gap-2 font-semibold">
                <span className=" text-black">Wallet Balance :</span>{" "}
                <span className="text-blue-400">{walletAmount}</span>
              </div>
            )}
          </Row>
        </div>
        <Form.Item>
          <div className="flex gap-2 justify-end mt-5">
            <button
              className="border rounded-lg bg-white text-sm w-20"
              onClick={handleCancelClick}
            >
              Cancel
            </button>
            {paymentType == "Digital" ? (
              <>
                <button
                  className="bg-brand-primaryColor border rounded-lg  w-40 p-2 text-sm text-white disabled:bg-gray-400"
                  type="primary"
                  disabled={
                    save || loginResultObject.user.currencyCode !== "INR"
                  }
                  htmlType="submit"
                  onClick={() => handleSubmitType("3")}
                >
                  Share Payment Link
                </button>
                <button
                  className="border rounded-lg bg-brand-primaryColor w-28 text-white"
                  type="primary"
                  disabled={save}
                  htmlType="submit"
                  onClick={() => handleSubmitType("1")}
                >
                  {callType === "APPT_VIDEO" ? "Pay Now" : "Pay & Schedule"}
                </button>
                {/* <button
                  className="border bg-brand-primaryColor rounded-lg text-white p-2 text-sm"
                  type="primary"
                  htmlType="submit"
                  disabled={save}
                  onClick={() => handleSubmitType("2")}
                >
                  {callType === "APPT_VIDEO" ? "Send Invite" : "Schedule"}
                </button> */}
              </>
            ) : (
              <>
                <button
                  className="border bg-brand-primaryColor rounded-lg text-white p-2 text-sm"
                  type="primary"
                  htmlType="submit"
                  disabled={save}
                  onClick={() => handleSubmitType("2")}
                >
                  {callType === "APPT_VIDEO" ? "Send Invite" : "Schedule"}
                </button>
              </>
            )}
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default AddNewPatient;
